import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Save, Send, Loader2 } from 'lucide-react';
import { inputClass, labelClass } from './adminUi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminThanksEmail = () => {
  const [cfg, setCfg] = useState({ subject: '', body: '' });
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/admin/settings`)
      .then((r) => {
        const t = r.data?.thanks_email;
        if (t) setCfg({ subject: t.subject || '', body: t.body || '' });
      })
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/settings`, { thanks_email: { subject: cfg.subject, body: cfg.body } });
      toast.success('Email de remerciement enregistré');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  const test = async () => {
    setTesting(true);
    try {
      const r = await axios.post(`${API}/admin/thanks-email/test`, { subject: cfg.subject, body: cfg.body });
      toast.success(`Email de test envoyé à ${r.data.to}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Échec de l'envoi de test");
    } finally {
      setTesting(false);
    }
  };

  return (
    <div data-testid="admin-thanks-email" className="max-w-2xl">
      <h2 className="font-heading text-2xl mb-2">Email de remerciement</h2>
      <p className="text-foreground/50 text-sm mb-6">Envoyé automatiquement après une commande. Personnalise-le puis envoie-toi un test.</p>
      <div className="space-y-4">
        <div>
          <label className={labelClass}>Sujet</label>
          <input className={inputClass} value={cfg.subject} onChange={(e) => setCfg({ ...cfg, subject: e.target.value })} placeholder="Merci pour votre commande" data-testid="thanks-subject" />
        </div>
        <div>
          <label className={labelClass}>Message</label>
          <textarea className={`${inputClass} min-h-[200px]`} value={cfg.body} onChange={(e) => setCfg({ ...cfg, body: e.target.value })} placeholder="Merci de votre confiance…" data-testid="thanks-body" />
        </div>
        <div className="flex gap-3">
          <button onClick={save} disabled={saving} className="btn-primary inline-flex items-center gap-2" data-testid="thanks-save">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Enregistrer
          </button>
          <button onClick={test} disabled={testing} className="btn-secondary inline-flex items-center gap-2" data-testid="thanks-test">
            {testing ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} M'envoyer un test
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminThanksEmail;
